import React, { useState } from 'react';
import BaseModal from 'src/common/components/Modal';
import { orderOfTheDayAPI } from 'src/api/modules/orderOfTheDay';
import notice from 'src/common/components/Notice';

const DeleteOrder = ({
	isOpen,
	onClose,
	order,
	//issue,
	//approval,
	//generalBusiness,
	//forKnowledge,
	//setApproval,
	//setGeneralBusiness,
	//setForKnowledge,
	onDeleteOrder,
}) => {
	const [isLoadingResponse, setIsLoadingResponse] = useState(false);
	const deleteOrder = () => {
		setIsLoadingResponse(true);
		return orderOfTheDayAPI
			.delete(order.id)
			.then((response) => {
				onClose(false);
				notice(`Orden eliminanda con éxito`, 'success');
				/*issue === 'Para aprobación'
					? setApproval(approval.filter((a) => a.id !== order.id))
					: issue === 'Para conocimiento'
					? setForKnowledge(forKnowledge.filter((k) => k.id !== order.id))
					: setGeneralBusiness(
							generalBusiness.filter((g) => g.id !== order.id)
					  );*/
				onDeleteOrder(response);
			})
			.catch(() => {
				notice(`Algo ha salido mal, intente de nuevo`, 'warning');
			})
			.finally((e) => {
				onClose(true);
				setIsLoadingResponse(false);
			});
	};

	return (
		<BaseModal
			open={isOpen}
			onClose={onClose}
			onCancel={onClose}
			onConfirm={deleteOrder}
			mainText={`¿Seguro que desea eliminar la orden seleccionada?`}
			disableOnConfirm={isLoadingResponse}
		></BaseModal>
	);
};

export default DeleteOrder;
